import { render, staticRenderFns } from "./DrawerHeader.vue?vue&type=template&id=15dbbec0&scoped=true&"
import script from "./DrawerHeader.vue?vue&type=script&lang=js&"
export * from "./DrawerHeader.vue?vue&type=script&lang=js&"
import style0 from "./DrawerHeader.vue?vue&type=style&index=0&id=15dbbec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dbbec0",
  null
  
)

export default component.exports